import React from 'react'
import Navbar from '../components/Navbar'
import EsgDetailsComponent from '../components/EsgDetails'
import Footer from '../components/Footer'
import Scroll from '../components/Utils'

const EsgDetails = () => {
    return (
        <>
            <Scroll />
            <Navbar />
            <EsgDetailsComponent />
            <Footer />
        </>
    )
}

export default EsgDetails